"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const selectLevel_1 = require("./utils/selectLevel");
const story = new selectLevel_1.storyLine("clickerGame");
story.getStoryLine();
(0, selectLevel_1.initializeLevel)(callBackLevel);
const score_1 = require("./utils/score");
let timeLeft = 0;
function callBackLevel(level) {
    if (level === "junior") {
        timeLeft = 100;
        randomPosition(1000);
    }
    else {
        timeLeft = 60;
        randomPosition(750);
    }
    startGame();
}
// Add null checks
const main = document.getElementsByTagName("main")[0];
const mainWidth = main.clientWidth;
const mainHeight = main.clientHeight;
const scoreText = document.getElementById("score");
const imgMates = document.createElement("img");
imgMates.style.position = "absolute";
imgMates.src = "./assets/mates-1.png";
const cursorHand = document.getElementById("cursorHand");
cursorHand.style.zIndex = "5";
//agar gambar cursorhand mengikuti pointer mouse
document.addEventListener("mousemove", (e) => {
    cursorHand.style.left = (e.clientX - 100) + "px";
    cursorHand.style.top = (e.clientY - 70) + "px";
});
let score = 0;
const countDown = document.getElementById("countDown");
let randomIntervalId;
function startGame() {
    let timerId = setInterval(function () {
        countDown.textContent = timeLeft.toString();
        timeLeft--;
        if (timeLeft < 0) {
            clearInterval(timerId);
            clearInterval(randomIntervalId);
            countDown.textContent = "TIME'S UP!";
            (0, score_1.getScore)(score, "clickerGame");
        }
    }, 1000);
}
const randomPosition = (timer) => {
    randomIntervalId = setInterval(function () {
        imgMates.src = "./assets/mates-1.png";
        const imgWidth = imgMates.clientWidth;
        const imgHeight = imgMates.clientHeight;
        const matesXPosition = Math.floor(Math.random() * (mainWidth - imgWidth));
        const matesYPosition = Math.floor(Math.random() * (mainHeight - imgHeight));
        imgMates.style.left = `${matesXPosition}px`;
        imgMates.style.top = `${matesYPosition}px`;
    }, timer);
};
imgMates.onload = () => {
    imgMates.style.width = "8%";
};
imgMates.addEventListener("click", function () {
    score++;
    imgMates.src = "./assets/mates-2.png";
    scoreText.innerHTML = `Score : ${score}`;
});
main.appendChild(imgMates);
